import React, { useEffect, useMemo, useRef, useState } from "react";
import styles from "./style.module.scss";
import MockBannerBg from "../../mock/banner-bg.jpg";
import MockPortrait from "../../mock/portrait.png";
import { useAsyncEffect } from "ahooks";
import { ReactComponent as LikeIcon } from "@/assets/icons/mySpace/white-like.svg";
import { ReactComponent as CollectIcon } from "@/assets/icons/mySpace/white-collect.svg";
import { ReactComponent as LookIcon } from "@/assets/icons/mySpace/white-look.svg";
import { loginStore, UserInfo } from "@/modules/login/store";
import { ReactComponent as PencilIcon } from "@/assets/icons/mySpace/pencil.svg";
import { useHistory } from "react-router";
import { BannerUserBaseInfo, BannerUserStatisticsInfo } from "@/types/mySpace";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { useOwnToast } from "@/utils/misc";

const GuestPath = "/artists";
interface IBanner {
  statisticsInfo: BannerUserStatisticsInfo | null;
  baseInfo: BannerUserBaseInfo | null;
  isGuest?: boolean;
  createFollow?: () => void;
  cancelFollow?: () => void;
}

const Banner: React.FC<IBanner> = ({
  statisticsInfo,
  baseInfo,
  isGuest = false,
  createFollow,
  cancelFollow,
}) => {
  const history = useHistory();
  const toast = useOwnToast();

  // useAsyncEffect(async () => {
  //   const info = await loginStore.getUserInfo();
  //   if (info?.data?.user) setUserInfo(info.data.user);
  // }, []);

  const handleSettingBtnClicked = () => {
    history.push("setting");
  };

  const handleFollow = () => {
    createFollow?.();
  };

  const handleCancelFollow = () => {
    cancelFollow?.();
  };

  const copyLinkCallback = () => {
    toast({
      description: "分享链接已经保存到剪贴板",
      status: "success",
      duration: 1500,
      position: "top",
    });
  };

  return (
    <div
      className={styles["banner-wrapper"]}
      style={{
        backgroundImage: `url(${baseInfo?.banner ? baseInfo?.banner : MockBannerBg}`,
        backgroundSize: `${100}%`,
      }}
    >
      {statisticsInfo && baseInfo && (
        <div className={styles["content-wrapper"]}>
          <div className={styles["portrait-wrapper"]}>
            <img src={baseInfo.avatar} alt="" />
          </div>
          <div className={styles["name"]}>{baseInfo.nickname}</div>
          <div className={styles["detail"]}>{baseInfo.describes}</div>
          {isGuest && (
            <div className={styles["guest-btn-wrapper"]}>
              <CopyToClipboard
                text={`${window.location.host}${GuestPath}/${baseInfo.user_id}`}
                onCopy={copyLinkCallback}
              >
                <button className={`${styles["guest-btn"]}`}>分享</button>
              </CopyToClipboard>

              {baseInfo.is_follow ? (
                <button className={`${styles["guest-btn"]}`} onClick={handleCancelFollow}>
                  已关注
                </button>
              ) : (
                <button
                  className={`${styles["guest-btn"]} ${styles["dangerous"]}`}
                  onClick={handleFollow}
                >
                  +关注
                </button>
              )}
            </div>
          )}

          <div className={styles["statistics-info-wrapper"]}>
            {/* 点赞 */}
            <div className={styles["social-item"]}>
              <LikeIcon className={styles["social-icon"]} />
              {statisticsInfo.likes_counter || 0}
            </div>
            {/* 收藏 */}
            {/* <div className={styles["social-item"]}>
              <CollectIcon className={styles["social-icon"]} />
              {statisticsInfo.favorites_counter || 0}
            </div> */}
            {/* 查看 */}
            <div className={styles["social-item"]}>
              <LookIcon className={styles["social-icon"]} />
              {statisticsInfo.views_counter || 0}
            </div>
          </div>
        </div>
      )}

      {!isGuest && (
        <div className={styles["personal-settings-btn"]} onClick={handleSettingBtnClicked}>
          <PencilIcon className={styles["pencil-icon"]} />
          个人设置
        </div>
      )}
    </div>
  );
};

export default Banner;
